import { actionTypes } from 'app/types/action_types';

const initialState = {
  pnpVideoUrl: null,
  hero: {},
  trendingSearchTerms: [],
  contentCategories: {
    establishing: [],
    featured: [],
    inspiredPills: [],
  },
  faq: [],
  faqHtml: null,
  faqSchema: null,
  heroHtml: null,
  categoryTilesPillsHtml: null,
  popularVideoSearchesHtml: null,
  choiceVideo: [],
};

const mapInitialPayloadAction = (state, payload) => ({
  ...state,
  pnpVideoUrl: payload.pnpVideoUrl,
  trendingSearchTerms: payload.trendingSearchTerms,
  hero: payload.hero,
  contentCategories: payload.contentCategories,
  faq: payload.faq,
  faqHtml: payload.faqHtml,
  faqSchema: payload.faqSchema,
  heroHtml: payload.heroHtml,
  categoryTilesPillsHtml: payload.categoryTilesPillsHtml,
  popularVideoSearchesHtml: payload.popularVideoSearchesHtml,
  choiceVideo: payload.choiceVideo,
});

// eslint-disable-next-line default-param-last
const videoLandingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapInitialPayloadAction(state, action.payload);
    default:
      return state;
  }
};

export default videoLandingPageReducer;
